import { ItemType } from '../../product-card/product.interface';
import { OfferTypeChecker } from '../../../common/utils/offer-type-util';
import { PaymentOrderItemData } from '../../order-confirmation/order-completion.interface';
import { ProductCardData } from '../../product-card/product-card-display';
import { UserOrderDetails } from '../../order-history/order-history.interface';
import { html, TemplateResult } from 'lit';

export const VIRTUAL_LABS = 'Virtual Labs';
export const VIRTUAL_LABS_ORDER_TYPE = 'virtuallab';

export function getVirtualLabsVerbiage(): TemplateResult {
  return html`
    <div class="rounded-1 mb-2">
      <h3 class="fw-bold fs-6 p-0 m-0">What's included:</h3>
      <ul id="product-info-verbiage-content" data-automation-id="product-info-verbiage-content" class="fs-small">
        <li>Lab simulations assigned by your instructor</li>
        <li>Pre- and post-lab assessment activities assigned by your instructor</li>
        <li>Reporting insights upon completion of assignments</li>
      </ul>
    </div>
  `;
}

/**
 * Verifies if the provided parameters indicate a virtual labs product or item.
 *
 * @param itemType
 * @param offerType
 * @param flow
 */
export function isVirtualLabs(
  itemType: string | undefined,
  offerType: string | undefined,
  flow: string | undefined
): boolean {
  return (
    itemType === ItemType.virtualLabs || OfferTypeChecker.isVirtualLabs(offerType) || flow === ItemType.virtualLabs
  );
}

/**
 * Verifies if the item (or product) is virtual labs.
 *
 * Note: item type for virtual labs is currently "connect", the item type check is included just in case it changes.
 *
 * @param itemType
 * @param offerType
 * @param flow
 */
export function isVirtualLabsItem({
  itemType,
  offerType,
  flow,
}: ProductCardData | PaymentOrderItemData | UserOrderDetails): boolean {
  return isVirtualLabs(itemType, offerType, flow);
}
